module.exports = __webpack_public_path__ + "static/media/4.21.4a671e49.png";